import React from "react";

type ValidationMessageProps = {
	message: string,
	valid: boolean,
	showBlankMessage?: boolean
}

const ValidationMessage = (props: ValidationMessageProps) => {
	const { message, valid, showBlankMessage = false } = props;

	if (!valid || showBlankMessage) {
		return (
			<span className="error-message">{valid ? "" : message}</span>
		);
	}

	return null;
}

export default ValidationMessage;
